import actions from './constants';

export const fetchRequestMarkdownSuccess = (category, code, result) => ({
  category,
  code,
  result,
  type: actions.FETCH_REQUEST_MARKDOWN_SUCCESS,
});

export const fetchRequestMarkdownError = (category, code, error) => ({
  category,
  code,
  error,
  type: actions.FETCH_REQUEST_MARKDOWN_ERROR,
});

export const closeRequestMarkdown = ({ category, code }) => ({
  category,
  code,
  type: actions.CLOSE_REQUEST_MARKDOWN,
});

export const downloadRequestMarkdown = (code) => ({
  type: actions.DOWNLOAD_REQUEST_MARKDOWN,
  code,
});

export const downloadRequestMarkdownError = (code, error) => ({
  type: actions.DOWNLOAD_REQUEST_MARKDOWN_ERROR,
  code,
  error,
});
